/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var Cart = (function () {
    'use strict';
    
    function _add() {
      var data = {
        quantity: 1,
        id: +window.theme.freeGiftCardId,
        properties: {
          'Gift Card 25$': 'Free'
        }
      };
      
      return fetch('/cart/add.js', _preparePostData(data));
    }

    function _addFreeProduct(freeProduct) {
      var data = {
        quantity: 1,
        id: freeProduct.id,
        properties: {
          '__min_subtotal_price': window.theme.minCartSubtotalForFreeItem,
          '__free_item': 'free'
        }
      }

      return fetch('/cart/add.js', _preparePostData(data)).then(function (res) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        return res.json();        
      });
    }
    
    function _remove(item) {
      var data = {
        quantity: 0,
        id: item.key,
      }
      
      return fetch('/cart/change.js', _preparePostData(data));
    }
    
    function _preparePostData(data) {
      return {
      	method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      }
    }
    
    function _getCart() {
      return fetch('/cart.js').then(function (res) {
      	return res.json();
      });
    }

    function _onCartUpdated() {
      fetch('/cart.js')
        .then(function(res) {
          return res.json();
        })
        .then(function(cart) {
          if (Array.isArray(dataLayer)) {
            dataLayer.push({event: 'cart_updated', cart: cart});
          }
        }).catch(function (err) {});
    }
    
    return {
      addGiftCard: _add,
      removeGiftCard: _remove,
      get: _getCart,
      addFreeProduct: _addFreeProduct,
      onCartUpdated: _onCartUpdated,
    }
  })();
  
  var minAmountForFreeGiftCart = 125;
  var giftCardProp = 'Gift Card 25$';
  
  function handleAddingGiftCard() {
      setTimeout(function () {
        Cart.get().then(function (cart) {
          var cartAmount = cart.items.filter(function(item) {
            return !item.properties.hasOwnProperty(giftCardProp);
          }).reduce(function(acc, cur) {
          	return acc + cur.line_price / 100;
          }, 0);

          isFreeGiftCardPresented = cart.items.filter(function(item) {
            return item.properties.hasOwnProperty(giftCardProp);
          });
		
          if (cartAmount >= minAmountForFreeGiftCart && !isFreeGiftCardPresented.length) {
            Cart.addGiftCard().then(function(data) {
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                  detail: {
                    quantity: 1
                  }
                }));
            });
          } else if (cartAmount < minAmountForFreeGiftCart && isFreeGiftCardPresented.length) {
          	Cart.removeGiftCard(isFreeGiftCardPresented.pop()).then(function(data) {
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {   
                  detail: {
                    quantity: -1
                  }
                }));
            });
          }
        });
      }, 600);
  }

  function addFreeProduct(cart) {
    var cartSubtotal = cart.total_price / 100;
    var isFreeProductAdded = false;

    cart.items.forEach(function (item) {
      if (item.id == window.theme.freeItem.id) {
        isFreeProductAdded = true;
      }
    });

    var cartCount = document.querySelector('span.header__cart-count');
    if ( ! isFreeProductAdded && cartSubtotal > window.theme.minCartSubtotalForFreeItem) {
      Cart.addFreeProduct(window.theme.freeItem).then(function(data) {
        var productsAmount =  cart.item_count + data.quantity;
        setTimeout(function() {
          cartCount.innerHTML = productsAmount;
        }, 600);
      });
    }
  }

  var delegateRoot = new domDelegate.Delegate(document.documentElement);
  // var qtyBtn = document.querySelectorAll('.quantity-selector__button');
  // var qtyBtnArr = [].slice.call(qtyBtn); 

  // qtyBtnArr.forEach(function(btn) {
  //   btn.addEventListener('click', function() {
  //     if (window.theme.freeItemEnabled) {
  //       Cart.get().then(function(cart) {
  //         addFreeProduct(cart);
  //       });
  //     }
  //   });
  // });

  document.addEventListener('product:added', function(event) {
    // add free item
    if (window.theme.freeItemEnabled) {
      Cart.get().then(function(cart) {
        addFreeProduct(cart);
      });
    }
    Cart.onCartUpdated();
  });

  delegateRoot.on('blur', '.quantity-selector__value', function() {
    if (window.theme.freeItemEnabled) {
      Cart.get().then(function(cart) {
        addFreeProduct(cart);
      });
    }
  });

  if (window.theme.isFreeGiftCardEnabled) {    
    document.addEventListener('product:added', handleAddingGiftCard);
    
    document.addEventListener('click', function(e) {
      switch(e.target.className) {
        case 'line-item__quantity-remove link':
        case 'mini-cart__quantity-remove link':
        case 'quantity-selector__button':  handleAddingGiftCard(); break;
      }
    });
    
    delegateRoot.on('blur', '.quantity-selector__value', handleAddingGiftCard);
  }

  if (document.querySelector('.custom-dots')) {
    const dots = document.querySelectorAll('.custom-dots li')
    const thumbnails = document.querySelectorAll('.product-gallery__thumbnail-list .product-gallery__thumbnail');

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        dots.forEach(item => item.classList.remove('active'));
        
        dot.classList.add('active')
        thumbnails[index].click();
      })
    })
  }

  const productListContainer = document.querySelector('.product-list');
  if (productListContainer) {
    const triggers = document.querySelectorAll('.collection__layout__trigger');
  
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        triggers.forEach((t) => t.classList.remove('is-selected'));
        trigger.classList.add('is-selected');
        
        const action = e.target.dataset.triggerAction;
  
        productListContainer.querySelectorAll('.product-item').forEach((item) => {
          item.classList.remove('1/3--tablet-and-up', '1/3--wide', '1/2--wide');
  
          if (action === 'square') {
            item.classList.add('1/3--tablet-and-up', '1/2--wide');
          } else if (action === 'grid') {
            item.classList.add('1/3--tablet-and-up', '1/3--wide');
          }
        });
      });
    });
  }



})();

document.addEventListener("DOMContentLoaded", function () {
  // Get references to the button and the target element
  const scrollButton = document.getElementById("button-write-review");

  if(!scrollButton) return;

  const targetElement = document.getElementById("shopify-section-product-reviews");
  const stickyHeader = document.getElementById("shopify-section-header");

  // Add a click event listener to the button
  scrollButton.addEventListener("click", function () {
    if (!targetElement) return;
    // Calculate the offset by subtracting the height of the sticky header
    const offset = stickyHeader ? stickyHeader.offsetHeight : 0;
    // Scroll to the target element with an offset
    window.scrollTo({
      top: targetElement.offsetTop - offset,
      behavior: "smooth", // You can also use "auto" for instant scrolling
    });
  });
});